<template>
	<div class="phenviron">
		<hpheader></hpheader>
		<div class="phvir-hea">{{info.around}}</div>
		<div class="phenviron-scrl">
			<div class="phenvirscrl-item" v-for="(item,index) in companyarou" :key="index">
				<img :src="item.images" />
<!--				<div class="phenvirite-title">{{item.title}}</div>-->
			</div>
		</div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				companyarou:'',
			}
		},
		created() {
			window.scrollTo(0,0);
			this.pccompanyaround()
			
			this.pageParam()
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			
				this.$router.push({path:'./pcabout',query:{e:2}})
			}
			this.ress()
		},
		components:{
			hpfooter,
			hpheader
		},
		methods:{
			pccompanyaround(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					mold:'pc',
					page:1,
					pageSize:5,
						
					}
				this.$api.get_company_around(data).then((res) => {
					this.companyarou=res.data
				});
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
				this.leftuscreated =  [
					{'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
					{'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
				]
				this.rightuscreated =  [
					{'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
					{'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的，梦想'},
		
				]
				this.year = "年"
				this.info = {
					'about': "关于啄木鸟",
					'around': "公司环境",
					'honor': '公司荣誉',
					'news' : '新闻中心',
					'course' : '公司历程',
					'more' : "显示更多",
					'special': '专题',
				}
				}else{
				this.created = "Woodpecker creation"
				this.leftuscreated =  [
					{'ustitle':'Our core values','usmintitle':'Earnest, honest and grateful'},
					{'ustitle':'Our style','usmintitle':'Think there is a way, do it first, fast, accurate and obscene'},
				]
				this.rightuscreated =  [
					{'ustitle':'Our guidelines','usmintitle':'Loyal, serious, professional, innovative, pursuing excellence, taking customers as the core and changing everything for customers'},
					{'ustitle':'Our vision','usmintitle':'Create a world-class enterprise, be a pioneer in China, win the respect and trust of global customers, and realize the dream of woodpecker'},
				]
				this.year = "year"
				this.info = {
					'about': "About woodpecker",
					'around': "COMPANY ENVIRONMENT",
					'honor': 'Company honor',
					'news' : 'News Center',
					'course' : 'Company history',
					'more' : "More",
					'special': 'Special',
				}
		
				}
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phenviron{
		padding-top: 0.88rem;
		background: #FFF;
	}
	.phenviron-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phenvironhea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
	}
	.phenvironhea-left img{
		width: 100%;
		height: 100%;
	}
	.phenvironhea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phenvironhea-right img{
		width: 100%;
		height: 100%;
	}
	.phenviron-scrl{
		display: flex;
		overflow: auto;
		padding-right: 0.3rem;
		margin-bottom: 0.6rem;
	}
	.phenvirscrl-item{
		width: 5.5rem;
		height: 5.5rem;
		position: relative;
		margin-left: 0.3rem;
	}
	.phenvirscrl-item img{
		width: 5.5rem;
		height: 5.5rem;
	}
	.phenvirite-title{
		position: absolute;
		top: 4.28rem;
		left: 2.07rem;
		font-size: 0.32rem;
		font-weight: 600;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
	}
	.phvir-hea{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.36rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin:  0.4rem 0;
	}
	
</style>
